import React, { useState, useEffect } from "react";
import { Button, Divider, TextField, } from "@mui/material";
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import EmailIcon from '@mui/icons-material/Email';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import PersonIcon from '@mui/icons-material/Person';
import { MascaraCartaoCredito } from "../../../utils/MascaraCartaoCredito";
import { MascaraDataCartaoCredito } from "../../../utils/MascaraDataCartaoCredito";
import { useNavigate } from "react-router-dom";
import { MascaraCpf } from "../../../utils/MascaraCpf";
import { MascaraTelefone } from "../../../utils/MascaraTelefone";
import { MascaraCep } from "../../../utils/MascaraCep";


export const StepForm = ({ modeloNegocio, setModeloNegocio, perguntas, respostas, setRespostas }) => {

    const handleSetResposta = (e, pergunta) => {
        const novasRespostas = { ...respostas, [pergunta.pergunta]: e.target.value };
        setRespostas(novasRespostas);
        localStorage.setItem("respostas", JSON.stringify(novasRespostas));
    }
    return (
        <>
            <div>
                <h2>Vamos começar!</h2>
                <p>Este diagnóstico foi desenvolvido para entender o momento atual da sua operação e identificar oportunidades estratégicas de crescimento, organização e otimização fiscal no mercado digital.</p>
                <span>Leva cerca de 5 a 10 minutos.</span>

                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
                    <TextField helperText="Limite de 80 caracteres" inputProps={{ maxLength: 80 }} sx={{ width: window.innerWidth < 600 ? "100%" : "49%" }} id="filled-basic" label={perguntas[0]?.pergunta} onChange={(e) => handleSetResposta(e, perguntas[0])} value={respostas[perguntas[0]?.pergunta] || ""} placeholder="Digite o nome da empresa" variant="filled" />
                    <TextField helperText="Limite de 50 caracteres" inputProps={{ maxLength: 50 }} sx={{ width: window.innerWidth < 600 ? "100%" : "49%" }} id="filled-basic" label={perguntas[1]?.pergunta} onChange={(e) => handleSetResposta(e, perguntas[1])} value={respostas[perguntas[1]?.pergunta] || ""} placeholder="Digite o segmento de atuação" variant="filled" />
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
                    <FormControl sx={{ width: "100%" }} component="fieldset">
                        <FormLabel>{perguntas[2]?.pergunta}</FormLabel>
                        <RadioGroup row value={respostas[perguntas[2]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[2])}>
                            <FormControlLabel value="Infoprodutos" control={<Radio />} label="Infoprodutos" />
                            <FormControlLabel value="Serviços" control={<Radio />} label="Serviços" />
                            <FormControlLabel value="E-commerce" control={<Radio />} label="E-commerce" />
                            <FormControlLabel value="Agência" control={<Radio />} label="Agência" />
                            <FormControlLabel value="Outro" control={<Radio />} label="Outro" />
                        </RadioGroup>
                    </FormControl>
                </div>
                {respostas[perguntas[2]?.pergunta] === "Outro" ? (
                    <>
                        <TextField sx={{ width: "100%", marginTop: "20px" }} value={modeloNegocio} onChange={(e) => setModeloNegocio(e.target.value)} id="filled-basic" label="Por favor, especifique seu modelo de negócio" placeholder="Descreva brevemente seu modelo de negócio" variant="filled" />
                    </>
                ) : ("")}
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
                    <FormControl sx={{ width: "100%" }} component="fieldset">
                        <FormLabel>Qual seu faturamento médio mensal?</FormLabel>
                        <RadioGroup row value={respostas[perguntas[3]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[3])}>
                            <FormControlLabel value="Até R$ 10.000" control={<Radio />} label="Até R$ 10.000" />
                            <FormControlLabel value="R$ 10.000 a R$ 50.000" control={<Radio />} label="R$ 10k a R$ 50k" />
                            <FormControlLabel value="R$ 50.000 a R$ 200.000" control={<Radio />} label="R$ 50k a R$ 200k" />
                            <FormControlLabel value="Acima de R$ 200.000" control={<Radio />} label="Acima de R$ 200k" />
                        </RadioGroup>
                    </FormControl>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
                    <TextField helperText="Limite de 250 caracteres" multiline rows={2} value={respostas[perguntas[4]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[4])} sx={{ width: window.innerWidth < 600 ? "100%" : "49%" }} id="filled-basic" label="Qual é o principal propósito do seu negócio hoje? (Missão)" placeholder="Digite o principal propósito do seu negócio" variant="filled" />
                    <TextField helperText="Limite de 250 caracteres" multiline rows={2} value={respostas[perguntas[5]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[5])} sx={{ width: window.innerWidth < 600 ? "100%" : "49%" }} id="filled-basic" label="Quais princípios você considera inegociáveis na sua empresa? (Valores)" placeholder="Digite os valores da sua empresa" variant="filled" />
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
                    <TextField helperText="Limite de 250 caracteres" multiline rows={3} value={respostas[perguntas[6]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[6])} sx={{ width: "100%" }} id="filled-basic" label="Onde você quer que a empresa esteja nos próximos 2 a 3 anos? (Visão)" placeholder="Digite a visão da sua empresa" variant="filled" />
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
                    <TextField helperText="Limite de 250 caracteres" multiline rows={2} value={respostas[perguntas[7]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[7])} sx={{ width: window.innerWidth < 600 ? "100%" : "49%" }} id="filled-basic" label="O que hoje você considera que sua empresa faz muito bem?" placeholder="Digite o que sua empresa faz muito bem" variant="filled" />
                    <TextField helperText="Limite de 250 caracteres" multiline rows={2} value={respostas[perguntas[8]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[8])} sx={{ width: window.innerWidth < 600 ? "100%" : "49%" }} id="filled-basic" label="Quais são os principais desafios internos hoje?" placeholder="Digite os principais desafios internos da sua empresa" variant="filled" />
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
                    <TextField helperText="Limite de 250 caracteres" multiline rows={2} value={respostas[perguntas[9]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[9])} sx={{ width: window.innerWidth < 600 ? "100%" : "49%" }} id="filled-basic" label="Onde você enxerga potencial de crescimento?" placeholder="Digite onde você enxerga potencial de crescimento" variant="filled" />
                    <TextField helperText="Limite de 250 caracteres" multiline rows={2} value={respostas[perguntas[10]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[10])} sx={{ width: window.innerWidth < 600 ? "100%" : "49%" }} id="filled-basic" label="O que hoje pode impactar negativamente seu negócio?" placeholder="Digite os fatores que podem impactar negativamente seu negócio" variant="filled" />
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
                    <FormControl sx={{ width: "100%" }} component="fieldset">
                        <FormLabel>Você acompanha concorrentes ou referências de mercado?</FormLabel>
                        <RadioGroup row value={respostas[perguntas[11]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[11])}>
                            <FormControlLabel value="Sim" control={<Radio />} label="Sim" />
                            <FormControlLabel value="Não" control={<Radio />} label="Não" />
                        </RadioGroup>
                    </FormControl>
                </div>
                {respostas[perguntas[11]?.pergunta] === "Sim" ? (
                    <>
                        <TextField helperText="Limite de 250 caracteres" multiline rows={2} value={respostas[perguntas[12]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[12])} sx={{ width: "100%", marginTop: "20px" }} id="filled-basic" label="Se sim, cite 2 ou 3 que você considera referência" placeholder="Digite as referências" variant="filled" />
                        <TextField helperText="Limite de 250 caracteres" multiline rows={2} value={respostas[perguntas[13]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[13])} sx={{ width: "100%", marginTop: "20px" }} id="filled-basic" label="O que eles fazem melhor que você hoje?" placeholder="Digite o que eles fazem melhor" variant="filled" />
                    </>
                ) : ("")}
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
                    <FormControl sx={{ width: "100%" }} component="fieldset">
                        <FormLabel>Hoje você possui um planejamento estruturado de crescimento?</FormLabel>
                        <RadioGroup row value={respostas[perguntas[14]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[14])}>
                            <FormControlLabel value="Sim, bem definido" control={<Radio />} label="Sim, bem definido" />
                            <FormControlLabel value="Parcialmente" control={<Radio />} label="Parcialmente" />
                            <FormControlLabel value="Não tenho" control={<Radio />} label="Não tenho" />
                        </RadioGroup>
                    </FormControl>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
                    <TextField helperText="Limite de 250 caracteres" multiline rows={3} sx={{ width: "100%" }} id="filled-basic" label={perguntas[15]?.pergunta} value={respostas[perguntas[15]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[15])} placeholder="Digite suas prioridades" variant="filled" />
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
                    <FormControl sx={{ width: "100%" }} component="fieldset">
                        <FormLabel>{perguntas[16]?.pergunta}</FormLabel>
                        <RadioGroup row value={respostas[perguntas[16]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[16])}>
                            <FormControlLabel value="Sim" control={<Radio />} label="Sim" />
                            <FormControlLabel value="Não" control={<Radio />} label="Não" />
                        </RadioGroup>
                    </FormControl>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
                    <FormControl sx={{ width: "100%" }} component="fieldset">
                        <FormLabel>{perguntas[17]?.pergunta}</FormLabel>
                        <RadioGroup row value={respostas[perguntas[17]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[17])}>
                            <FormControlLabel value="Sim" control={<Radio />} label="Sim" />
                            <FormControlLabel value="Não" control={<Radio />} label="Não" />
                            <FormControlLabel value="Parcialmente" control={<Radio />} label="Parcialmente" />
                        </RadioGroup>
                    </FormControl>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
                    <FormControl sx={{ width: "100%" }} component="fieldset">
                        <FormLabel>{perguntas[18]?.pergunta}</FormLabel>
                        <RadioGroup row value={respostas[perguntas[18]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[18])}>
                            <FormControlLabel value="Tributação" control={<Radio />} label="Tributação" />
                            <FormControlLabel value="Bloqueio de conta" control={<Radio />} label="Bloqueio de conta" />
                            <FormControlLabel value="Falta de contrato" control={<Radio />} label="Falta de contrato" />
                            <FormControlLabel value="Nenhum" control={<Radio />} label="Nenhum" />
                        </RadioGroup>
                    </FormControl>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
                    <FormControl sx={{ width: "100%" }} component="fieldset">
                        <FormLabel>{perguntas[19]?.pergunta}</FormLabel>
                        <RadioGroup row value={respostas[perguntas[19]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[19])}>
                            <FormControlLabel value="Sim" control={<Radio />} label="Sim" />
                            <FormControlLabel value="Não" control={<Radio />} label="Não" />
                        </RadioGroup>
                    </FormControl>
                </div>
                {respostas[perguntas[19]?.pergunta] === "Sim" ? (
                    <>
                        <TextField helperText="Limite de 250 caracteres" multiline rows={2} value={respostas[perguntas[20]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[20])} sx={{ width: "100%", marginTop: "20px" }} id="filled-basic" label="Quais métricas você acompanha hoje?" placeholder="Digite as métricas" variant="filled" />
                        <TextField helperText="Limite de 250 caracteres" multiline rows={2} value={respostas[perguntas[21]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[21])} sx={{ width: "100%", marginTop: "20px" }} id="filled-basic" label="Qual sua principal meta para os próximos 6 meses?" placeholder="Digite sua meta" variant="filled" />
                    </>
                ) : ("")}
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
                    <FormControl sx={{ width: "100%" }} component="fieldset">
                        <FormLabel>{perguntas[22]?.pergunta}</FormLabel>
                        <RadioGroup value={respostas[perguntas[22]?.pergunta] || ""} onChange={(e) => handleSetResposta(e, perguntas[22])}>
                            <FormControlLabel value="tem" control={<Radio />} label="Tenho uma contabilidade estruturada que me atende bem" />
                            <FormControlLabel value="melhorar" control={<Radio />} label="Tenho contabilidade, mas sinto que poderia melhorar" />
                            <FormControlLabel value="informal" control={<Radio />} label="Faço por conta própria / informal" />
                            <FormControlLabel value="nenhuma" control={<Radio />} label="Ainda não tenho essa estrutura" />
                        </RadioGroup>
                    </FormControl>
                </div>
            </div>
        </>
    )
}


export const StepOne = ({ nome, setNome, email, setEmail, cpf, setCpf }) => {
    return (
        <>
            <div>
                <h2>Falta pouco!</h2>
                <p>Para isso precisamos do seu melhor e-mail, é nele que enviaremos as informações importantes.</p>
            </div>
            <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px" }} >
                <FormControl fullWidth variant="standard">
                    <InputLabel>
                        Seu Nome
                    </InputLabel>
                    <Input
                        type="text"
                        value={nome}
                        onChange={(e) => { setNome(e.target.value) }}
                        autoComplete="off"
                        placeholder="Informe seu nome"
                        startAdornment={
                            <InputAdornment position="start">
                                <PersonIcon />
                            </InputAdornment>
                        }
                    />
                </FormControl>
            </div>
            <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px" }} >
                <FormControl fullWidth variant="standard">
                    <InputLabel>
                        Seu melhor e-mail
                    </InputLabel>
                    <Input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        autoComplete="off"
                        placeholder="Informe seu e-mail"
                        startAdornment={
                            <InputAdornment position="start">
                                <EmailIcon />
                            </InputAdornment>
                        }
                    />
                </FormControl>
            </div>
            <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px" }} >
                <FormControl fullWidth variant="standard">
                    <InputLabel>
                        Seu CPF
                    </InputLabel>
                    <Input
                        type="text"
                        value={MascaraCpf(cpf)}
                        onChange={(e) => setCpf(e.target.value)}
                        autoComplete="off"
                        placeholder="Informe seu CPF"
                        startAdornment={
                            <InputAdornment position="start">
                                <AssignmentIndIcon />
                            </InputAdornment>
                        }
                    />
                </FormControl>
            </div>
        </>
    )
}


export const StepTwo = ({ email, codigoVerificacao, setCodigoVerificacao }) => {
    return (
        <>
            <div>
                <h2>Confirmação de e-mail</h2>
                <p>Enviamos um código de verificação para o e-mail "{email}", por favor, insira-o abaixo.</p>
            </div>
            <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px" }} >
                <FormControl sx={{ width: "70%" }} variant="standard">
                    <InputLabel>
                        Código de verificação
                    </InputLabel>
                    <Input
                        type="text"
                        autoComplete="off"
                        placeholder="Código de verificação"
                        value={codigoVerificacao}
                        onChange={(e) => setCodigoVerificacao(e.target.value)}
                        startAdornment={
                            <InputAdornment position="start">
                                <MarkEmailReadIcon />
                            </InputAdornment>
                        }
                    />
                </FormControl>
            </div>
        </>
    )
}


export const StepThree = ({ options, selected, setSelected }) => {
    return (
        <>
            <div>
                <h2>Escolha o que melhor se adapta a você</h2>
                <p>Temos duas opções, escolha a que melhor atende às suas necessidades.</p>
            </div>

            <div style={{ display: "flex", gap: "10px", marginTop: "20px", flexWrap: "wrap", justifyContent: "center" }}>
                {options.map((option) => (
                    <div
                        key={option.id}
                        onClick={() => setSelected(option.id)}
                        className={`card ${selected === option.id ? "selected" : ""}`}
                    >
                        <h3>{option.title}</h3>
                        <p>{option.description}</p>
                        <strong>{option.price}</strong>
                    </div>
                ))}
            </div>
            <div>
                <h3>O que a consultoria inclui?</h3>
                <span>Um dos nossos consultores especializados irá analisar sua situação e fornecer recomendações personalizadas.</span>
            </div>
        </>
    )
}


export const StepFour = ({ selected, tipoPagamento, setTipoPagamento, step }) => {
    return (
        <>
            <div>
                <h2>Quase lá!</h2>
                <p>Revise seu pedido e prossiga para o pagamento.</p>
            </div>
            <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                <span><strong>Opção escolhida:</strong> {selected === "conteudo" ? "Apenas conteúdo" : "Conteúdo + Consultoria"}</span>
                <span style={{ minWidth: "80px" }}>{selected === "conteudo" ? "R$ 50,00" : "R$ 165,00"}</span>
            </div>
            <Divider sx={{ margin: "20px 0" }} />
            <div style={{ width: "100%" }}>
                <FormControl disabled={step === 5} component="fieldset">
                    <FormLabel id="demo-row-radio-buttons-group-label">Escolha a forma de pagamento</FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={tipoPagamento}
                        onChange={(e) => setTipoPagamento(e.target.value)}
                    >
                        <FormControlLabel disabled value="PIX" control={<Radio />} label="PIX" />
                        <FormControlLabel value="CARTAO" control={<Radio />} label="Cartão de Crédito" />
                    </RadioGroup>
                </FormControl>
            </div>
        </>
    )
}


export const StepFive = ({ tipoPagamento, showBack, setShowBack, cardData, setCardData, cardErrors, setCardErrors, encodedImage, payload }) => {
    const [copiado, setCopiado] = useState(false);

    const copiar = async () => {
        await navigator.clipboard.writeText(payload);
        setCopiado(true);
        setTimeout(() => setCopiado(false), 2000);
    };


    const handleCardInputChange = (e) => {
        setCardData({ ...cardData, [e.target.name]: e.target.value });
    };
    return (
        <>
            {tipoPagamento === "PIX" ? (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px" }}>
                    <h2>Pagamento via PIX</h2>
                    <p>Escaneie o QR code abaixo com seu aplicativo bancário para realizar o pagamento.</p>
                    <img src={`data:image/png;base64,${encodedImage}`} alt="QR Code" style={{ width: "200px", height: "200px" }} />
                    <span>Você também pode com um clique copiar o código abaixo e colar no seu aplicativo bancário:</span>
                    <span
                        onClick={copiar}
                        style={{ textAlign: "center", cursor: "pointer", padding: "10px", backgroundColor: "#f0f0f0", borderRadius: "5px" }}
                    >
                        {copiado ? "Copiado!" : payload}
                    </span>
                </div>
            ) : (
                <div style={{ width: "100%", height: "fit-content" }}>
                    <h2>Pagamento via Cartão de Crédito</h2>
                    <div
                        style={{
                            marginTop: "20px",
                            display: "flex",
                            flexDirection: window.innerWidth < 600 ? "column" : "row",
                            gap: "40px",
                            height: "fit-content",
                            marginBottom: "20px",
                        }}
                    >
                        {/* Formulário */}
                        <div
                            style={{
                                // flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                gap: "15px",
                                maxWidth: "100%",
                                height: "fit-content",
                            }}
                        >
                            <TextField
                                label="Nome no Cartão"
                                fullWidth
                                size="small"
                                placeholder="Ex: João da Silva"
                                name="name"
                                value={cardData.name}
                                onChange={handleCardInputChange}
                                helperText={cardErrors.name}
                                error={Boolean(cardErrors.name)}
                            />

                            <TextField
                                label="Número do Cartão"
                                fullWidth
                                size="small"
                                inputProps={{ maxLength: 19 }}
                                placeholder="0000 0000 0000 0000"
                                name="number"
                                value={MascaraCartaoCredito(cardData.number)}
                                onChange={handleCardInputChange}
                                helperText={cardErrors.number}
                                error={Boolean(cardErrors.number)}
                            />

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: window.innerWidth < 600 ? "column" : "row",
                                    gap: "15px",
                                }}
                            >
                                <TextField
                                    label="Validade (MM/AAAA)"
                                    size="small"
                                    placeholder="MM/AAAA"
                                    inputProps={{ maxLength: 7 }}
                                    name="expiry"
                                    value={MascaraDataCartaoCredito(cardData.expiry)}
                                    onChange={handleCardInputChange}
                                    fullWidth
                                    helperText={cardErrors.expiry}
                                    error={Boolean(cardErrors.expiry)}
                                />

                                <TextField
                                    label="CVV"
                                    size="small"
                                    placeholder="123"
                                    inputProps={{ maxLength: 3 }}
                                    name="cvv"
                                    value={cardData.cvv}
                                    onChange={handleCardInputChange}
                                    onFocus={() => setShowBack(true)}  // mostra verso
                                    onBlur={() => setShowBack(false)}  // volta para frente
                                    fullWidth
                                    helperText={cardErrors.cvv}
                                    error={Boolean(cardErrors.cvv)}
                                />
                            </div>
                            <span>Dados Pessoais</span>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: window.innerWidth < 600 ? "column" : "row",
                                    gap: "15px",
                                }}
                            >
                                <TextField
                                    label="CPF"
                                    size="small"
                                    placeholder="000.000.000-00"
                                    inputProps={{ maxLength: 14 }}
                                    name="cpf"
                                    value={MascaraCpf(cardData.cpf)}
                                    onChange={handleCardInputChange}
                                    fullWidth
                                    helperText={cardErrors.cpf}
                                    error={Boolean(cardErrors.cpf)}
                                />

                                <TextField
                                    label="Telefone"
                                    size="small"
                                    placeholder="(00) 00000-0000"
                                    inputProps={{ maxLength: 15 }}
                                    name="telefone"
                                    value={MascaraTelefone(cardData.telefone)}
                                    onChange={handleCardInputChange}
                                    fullWidth
                                    helperText={cardErrors.telefone}
                                    error={Boolean(cardErrors.telefone)}
                                />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: window.innerWidth < 600 ? "column" : "row",
                                    gap: "15px",
                                }}
                            >
                                <TextField
                                    label="CEP"
                                    size="small"
                                    placeholder="00000-000"
                                    inputProps={{ maxLength: 9 }}
                                    name="cep"
                                    value={MascaraCep(cardData.cep)}
                                    onChange={handleCardInputChange}
                                    fullWidth
                                    helperText={cardErrors.cep}
                                    error={Boolean(cardErrors.cep)}
                                />

                                <TextField
                                    label="Número de residência"
                                    size="small"
                                    placeholder="123"
                                    inputProps={{ maxLength: 3 }}
                                    name="numeroResidencia"
                                    value={cardData.numeroResidencia}
                                    onChange={handleCardInputChange}
                                    fullWidth
                                    helperText={cardErrors.numeroResidencia}
                                    error={Boolean(cardErrors.numeroResidencia)}
                                />
                            </div>
                        </div>
                        {/* Cartão com efeito flip */}
                        <div
                            style={{
                                flex: 1,
                                perspective: "1000px",
                                maxWidth: "300px",
                                maxHeight: "150px",
                                display: window.innerWidth < 600 ? "none" : "block",
                            }}
                        >
                            <div
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "12px",
                                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    color: "white",
                                    fontFamily: "monospace",
                                    transition: "transform 0.6s",
                                    transformStyle: "preserve-3d",
                                    transform: showBack ? "rotateY(180deg)" : "rotateY(0deg)",
                                    position: "relative",
                                }}
                            >
                                {/* Frente do cartão */}
                                <div
                                    style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        backfaceVisibility: "hidden",
                                        background: "linear-gradient(135deg, #000000ff, #0a1a12d3)",
                                        borderRadius: "12px",
                                        padding: "20px",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <div style={{ fontSize: "0.9rem" }}>CARTÃO DE CRÉDITO</div>
                                    <div style={{ fontSize: "1.2rem", letterSpacing: "2px" }}>
                                        {cardData.number || "0000 0000 0000 0000"}
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            fontSize: "0.9rem",
                                        }}
                                    >
                                        <span>{cardData.name || "NOME DO TITULAR"}</span>
                                        <span>{cardData.expiry || "MM/AA"}</span>
                                    </div>
                                </div>

                                {/* Verso do cartão */}
                                <div
                                    style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        backfaceVisibility: "hidden",
                                        background: "#0a1a12d3",
                                        borderRadius: "12px",
                                        padding: "20px",
                                        transform: "rotateY(180deg)",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                    }}
                                >
                                    <div
                                        style={{
                                            background: "#000",
                                            height: "40px",
                                            marginBottom: "20px",
                                            borderRadius: "4px",
                                        }}
                                    />
                                    <div
                                        style={{
                                            alignSelf: "flex-end",
                                            background: "#fff",
                                            color: "#000",
                                            padding: "5px 10px",
                                            borderRadius: "6px",
                                            fontWeight: "bold",
                                            minWidth: "60px",
                                            textAlign: "center",
                                        }}
                                    >
                                        {cardData.cvv || "•••"}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}


export const StepSix = () => {
    const navigate = useNavigate();
    // Carregar script do Calendly
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://assets.calendly.com/assets/external/widget.js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const handleFinalizar = () => {
        localStorage.removeItem("idCobrancaAsaas");
        localStorage.removeItem("emailForm");
        localStorage.removeItem("cpf");
        localStorage.removeItem("nome");
        localStorage.removeItem("respostas");
        localStorage.removeItem("selectedOption");
        localStorage.removeItem("stepAtual");
        localStorage.removeItem("steps");
        navigate("/");
    }

    return (
        <>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", height: "fit-content" }}>
                <h3 style={{ margin: 0 }}>Pagamento confirmado!</h3>
                <p>Obrigado por sua compra. Em breve você receberá um e-mail com as informações para acessar seu conteúdo.</p>
                <div style={{ textAlign: "center", width: "100%" }}>
                    <h2>Agende sua consultoria conosco</h2>
                    <p>Escolha o dia e horário que seja conveniente para você.</p>
                </div>
                <div
                    className="calendly-inline-widget"
                    data-url="https://calendly.com/personal-contblack/primeiros-passos-contblack-clone-1?primary_color=1eff86"
                    style={{ minWidth: "320px", width: "100%", height: "600px", marginTop: "0px", paddingTop: "0px" }}
                >

                </div>
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "16px",
                        marginTop: "20px",
                        textAlign: "center",
                    }}
                >
                    <span style={{ maxWidth: "400px" }}>
                        Após agendar sua reunião, você pode finalizar o processo.
                    </span>

                    <Button
                        variant="outlined"
                        sx={{
                            borderColor: "#1EFF86",
                            color: "black",
                            textTransform: "none",
                            px: 3,
                            py: 1,
                            "&:hover": {
                                backgroundColor: "#1EFF86",
                                borderColor: "#1EFF86",
                                color: "black",
                            },
                        }}
                        onClick={() => handleFinalizar()}
                    >
                        Finalizar
                    </Button>
                </div>
            </div>
        </>
    )
}